import React, { useEffect, useState, useCallback } from 'react'
import cn from 'classnames/bind'
import takeLast from 'ramda/es/takeLast'
import { useTranslation } from 'react-i18next'

import useErrors from'./use-errors'
import styles from './errors-display.module.scss'


const cx = cn.bind(styles)
const TIMEOUT_ERROR_INACTIVE_INTERVAL = 60000

const ErrorsDisplay = () => {
  const [errors, errorsActions, timeoutError] = useErrors()
  const [online, setOnline] = useState(true)
  const [active, setActive] = useState(false); // для анимации появления ошибки
  const { t } = useTranslation()

  useEffect(() => {
    if (errors.length) {
      setTimeout(() => setActive(true), 60)
    } else {
      setActive(false)
    }
  }, [errors])

  const handleClose = useCallback(() => {
    setActive(false)
    setTimeout(() => errorsActions.clearErrors(), 450)
  }, [errorsActions])

  const lastErrors = takeLast(3, errors)

  /**
   * timeout
   */

  const [timeoutVisible, setTimeoutVisible] = useState(true)
  const handleTimeoutClose = useCallback(() => {
    setTimeoutVisible(false)
    setTimeout(() => {
      errorsActions.resetTimeoutError()
      setTimeoutVisible(true)
    }, TIMEOUT_ERROR_INACTIVE_INTERVAL) // столько не будет показываться сообщение о недоступности данных, даже если соединение не восстановится
  }, [errorsActions])

  /**
   * online / offline indication
   */

  const handleGoOnline = useCallback(() => {
    setActive(false)
    setTimeout(() => setOnline(true), 450)
  }, [])
  const handleGoOffline = useCallback(() => {
    setOnline(false)
    setTimeout(() => setActive(true), 60)
  }, [])

  useEffect(() => {
    window.addEventListener('online', handleGoOnline)
    window.addEventListener('offline', handleGoOffline)
    return () => {
      window.removeEventListener('online', handleGoOnline)
      window.removeEventListener('offline', handleGoOffline)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <div>
      {/* {errors.length > 2
        && <div className={cx(styles.item, { active, warning: true })}>
          <span className={styles['item--content']}>
            {t(
              'template_cafeteria_menu.api_errors.too_many',
              'Болeе двух ошибок в короткое время, возможно отсутствует соединение с Интернет'
            )}
          </span>
          <button className={styles['item--close']}>
            {t('emplate_cafeteria_menu.api_errors.bt_reset', 'Обновить')}
          </button>
        </div>} */}

      {lastErrors.map(({ text, time }, i) => (
        <div className={cx(styles.item, { active })} key={time}>
          <span className={styles['item--content']}>
            {text}
          </span>

          {i === (lastErrors.length - 1)
            && <button
              className={styles['item--close']}
              onClick={handleClose}
            >
              &times;
            </button>}
        </div>
      ))}

      {!online
        && <div className={cx(styles.item, styles.warning, { active })}>
          <span className={styles['item--content']}>
            {t(
              'template_cafeteria_menu.api_errors.offline',
              'Нет соединения с интернет, возможно данные не актуальны на текущий момент'
            )}
          </span>
        </div>}

      {/* На весь экран, нет данных ни с сервера, ни с service-worker */}
      {timeoutError
        && timeoutVisible
        && <div className={styles.timeout}>
          <div className={styles['timeout--text']}>
            {t(
              'template_cafeteria_menu.api_errors.timeout',
              'Не удалось получить данные, возможно отсутствует соединение с интеренет'
            )}
          </div>
          <div className={styles.buttons}>
            <button
              className={styles['timeout--button']}
              onClick={errorsActions.resetApp}
            >
              {t('template_cafeteria_menu.api_errors.bt_reset', 'Обновить')}
            </button>
            <button
              className={styles['timeout--button']}
              onClick={handleTimeoutClose}
            >
              {t('template_cafeteria_menu.api_errors.bt_close', 'Закрыть')}
            </button>
          </div>
        </div>}
    </div>
  )
}

export default ErrorsDisplay
